import React from 'react';

import { green } from 'lib/v2/colors';

// material-core
import { styled } from '@mui/material/styles';
import MuiSwitch from '@mui/material/Switch';

// styling pulled almost completely from the MUI docs gallery
const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: theme.spacing(1),
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: green,
        opacity: 1,
        border: 'none',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: green,
      border: `6px solid ${theme.palette.common.white}`,
    },
  },
  '& .MuiSwitch-thumb': {
    width: 24,
    height: 24,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[500]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
}));

export default function TswSwitch(props) {
  return <StyledSwitch disableRipple {...props} />;
}
